import {Skill, SkillApi} from "@betrue/shared/interfaces";
import {gql, useLazyQuery} from "@apollo/client";
import {useState, useEffect} from 'react';

export const AUTOCOMPLETE_SKILLS = gql`
  query AutoCompleteSkills($search: String!) {
    autoComplete(search: $search) {
      id
      key
      label
    }
  }
`;

export const useAutocomplete = (): [SkillApi, Skill[]] => {
  const [result, setResult] = useState<Skill[]>([]);

  const [autocomplete, {loading, error, data}] = useLazyQuery(AUTOCOMPLETE_SKILLS,
    {fetchPolicy: 'network-only',})

  useEffect(() => {
    if (!loading && data?.autoComplete) {
      setResult(data.autoComplete)

    }
  }, [loading, data, error])

  return [
    {
      autocomplete(query: string) {
        autocomplete({
          variables: {
            search: query
          }
        })
      }
    }, result]
}
